export default "__VITE_ASSET__3eV$a$Vx__"